// Landing pages for tools that can be granted to a Client account.
// The role itself grants no permissions; the backend also checks each route.
const CLIENT_LANDING_ROUTES = [
  ['clients:aluminium_offers', '/clients/aluminium-offers'],
  ['aluminium_deals:use', '/sales/aluminium-deals/discount'],
  ['aluminium_deals:montage', '/sales/aluminium-deals/montage'],
];

export const clientLandingPath = (permissions = []) =>
  CLIENT_LANDING_ROUTES.find(([permission]) => permissions.includes(permission))?.[1] || null;
